export default {"src":"/_next/static/media/ico_printer.f5c52766.svg","height":24,"width":23,"blurWidth":0,"blurHeight":0};